import { useCallback, useRef, useState } from 'react'

type DateFilters = {
  startCreatedDate?: string
  endCreatedDate?: string
  startModifiedDate?: string
  endModifiedDate?: string
}

export const useTicketState = () => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [sort, setSort] = useState('dateModified,desc')
  const [keyword, setKeyword] = useState('')
  const [status, setStatus] = useState('')
  const [typeOfConcern, setTypeOfConcern] = useState('')
  const [methodOfRepair, setMethodOfRepair] = useState('')
  const [dateFilters, setDateFilters] = useState<DateFilters>({
    startCreatedDate: '',
    endCreatedDate: '',
    startModifiedDate: '',
    endModifiedDate: '',
  })
  const [totalElements, setTotalElements] = useState(0)
  const [isLoading, setIsLoading] = useState(false)

  return {
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    keyword,
    setKeyword,
    dateFilters,
    setDateFilters,
    totalElements,
    setTotalElements,
    isLoading,
    setIsLoading,
    status,
    setStatus,
    typeOfConcern,
    setTypeOfConcern,
    methodOfRepair,
    setMethodOfRepair,
    sort,
    setSort,
  }
}

export const useDebounce = <T extends (...args: any[]) => void>(
  func: T,
  delay = 500,
) => {
  const timer = useRef<NodeJS.Timeout | null>(null)
  return useCallback(
    (...args: Parameters<T>) => {
      if (timer.current) clearTimeout(timer.current)
      timer.current = setTimeout(() => func(...args), delay)
    },
    [func, delay],
  )
}
